import * as React from 'react'
import { Helmet } from 'react-helmet-async'
import { PathPolicyHomeLayout } from '../../layouts/PathPolicy'

const PathPolicyHome = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Path Policy</title>
      <meta name="description" content="Path policy page" />
    </Helmet>
    <PathPolicyHomeLayout />
  </React.Fragment>
)

export default PathPolicyHome
